enum MediaTypes {
  BrandVideo = 'brandVideo',
  MidRollVideo = 'midRollVideo',
  InterstitialImage = 'interstitialImage'
};

export default MediaTypes;
